<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <b-row>
      <!-- post -->
      <b-col
          class="mx-auto"
          cols="12"
      >
        <profile-post :posts="posts"/>
      </b-col>

      <b-col
          class="mx-auto d-flex flex-row justify-content-center "
          cols="12"
      >
        <b-card>
          <QueriedPagination v-if="totalCount" v-model="currentPage" :total-counts="totalCount"
                             :per-page="perPage"></QueriedPagination>
        </b-card>
      </b-col>
      <!-- post -->
    </b-row>

  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import ProfilePost from "@/views/pages/profile/ProfilePost";
import {PostGetAllRequest} from "@/libs/Api/Post";
import QueriedPagination from "@/views/components/QueriedPagination.vue";

export default {
  title: 'لیست پست ها - پنل ادمین رها مزون',
  name: "PostList",
  data() {
    return {
      overlay:false,
      posts: null,
      totalCount: null,
      currentPage: 1,
      perPage: 5,
    }
  },
  watch:{
    getQuery: function (nv, ov) {
      this.getPosts();
    },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getPosts();
  },
  methods: {
    async getPosts() {
      let _this = this;
      _this.overlay = true;
      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage
      }
      let postGetAllRequest = new PostGetAllRequest(_this)
      postGetAllRequest.setParams(data);
      await postGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.posts = content.posts;
        _this.totalCount = content.postCount;
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
  },
  components: {
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    ProfilePost,

  },
}
</script>

<style scoped>

</style>
